// extracted by mini-css-extract-plugin
export default {"userDetails__collapseHeaderCell":"HeiUserTable_userDetails__collapseHeaderCell__sIWeP","userDetails__tableHeader":"HeiUserTable_userDetails__tableHeader__2T22h"};